<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-arrowup`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.8788 9.37721L11.3495 8.90748L8.68249 6.24049L8.60925 6.17408C8.23022 5.86479 7.67061 5.88713 7.31725 6.24049L4.65026 8.90748L5.12096 9.37721L5.59167 9.84791L7.99987 7.43873L10.4091 9.84791L10.8788 9.37721ZM4.65026 9.84791C4.90989 10.1074 5.332 10.1073 5.59167 9.84791L4.65026 8.90748C4.39127 9.16722 4.39084 9.58844 4.65026 9.84791ZM10.4091 9.84791C10.6687 10.107 11.0899 10.1071 11.3495 9.84791C11.609 9.58838 11.6087 9.16722 11.3495 8.90748L10.4091 9.84791Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineArrowup',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
